/**
 * THE STYLON TEAM (the owner's character sheet, 10-22) — the same pictures and layout as the portal's
 * stylon-salon-portal/src/Assets/characters. Each picture is the approved render with its eyes painted over and its
 * loose marks lifted out; characters.json says where they were, so StylonCharacter draws them alive. `growth` keeps
 * its painted eyes (they sit on two bars, not a pair).
 */
import ai from './ai.png';
import stylon from './stylon.png';
import bookings from './bookings.png';
import messages from './messages.png';
import payments from './payments.png';
import growth from './growth.png';
import products from './products.png';
import sales from './sales.png';
import courses from './courses.png';
import stays from './stays.png';
import marketing from './marketing.png';
import layout from './characters.json';

export const PICTURES = { ai, stylon, bookings, messages, payments, growth, products, sales, courses, stays, marketing };
export const LAYOUT = layout;
export const KINDS = Object.keys(PICTURES);
